import Toastify from 'toastify-js';
import 'toastify-js/src/toastify.css';
import { messages } from '../../i18n/message';

export function notify(key, type = 'info') {
  const lang = document.documentElement.lang || 'en';
  const text = messages[lang][key] || messages.en[key] || key;

  Toastify({
    text,
    duration: 4000,
    close: true,
    gravity: 'top',
    position: 'right',
    className: `toast-${type}`,
  }).showToast();
}
